import React from "react";
import { Tooltip } from 'antd';
import styles from "./scss/contactlist.module.scss";
import { URInput } from "../../../shared/widgets/input";
import { useState } from 'react';
import { getCurrentCallDetail, searchHandler, searchHighlight, toastInformation, userStatusColor } from '../../../base/callService/common';
import store from "../../../context/store/store";
import { URAvatarGroup } from "../../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../../shared/widgets/avatarGroup/statusDot";
import NoContent from "../../../shared/widgets/noContent";
import noResult from "../../../styles/images/empty_states/empty-nofound.svg";
import { useSelector } from "react-redux";
import { initialCallStateModel } from "../../../models/callModel";
import { incomingCallDetail } from "../../../base/callService/callsApiService";
import _ from "lodash";


type dailpadConatctListProps = {
  contactBackEvent?: any;
  selectedContact: any;
  dialpadUI?: any
  transferType?: string;
};

type dailpadConatctListState = {
  searchKey: string;
};

export default function DialPadContactLists({ contactBackEvent, selectedContact ,dialpadUI,transferType }: dailpadConatctListProps) {

  const [getContactList, setContactList] = useState<dailpadConatctListState>({ searchKey: '' });
  const { workContacts, favContacts } = store.getState().contactReducer;
  
  let { updatedCallList }: initialCallStateModel = useSelector((state: initialCallStateModel) => state);
  let activeCall: any = getCurrentCallDetail();
  let favList: Array<any> = _.filter(favContacts,((contacts:any)=>{
    return !Object.keys(contacts).some(key => key === 'team_id_prefix');
    })); 

  let resContact: any = searchHandler(workContacts,getContactList.searchKey);
  let filterresContact: any = resContact.filter((contact: any)=>{
    return contact.caller_id !==activeCall?.contact?.caller_id || 
    contact.ext !== activeCall?.contact?.ext
  })
 
  //let teamCont: any = teamContacs;
  let len = Math.ceil((filterresContact?.length / 8));
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();
  const closeContactPage = () => {
    contactBackEvent();
    //transferType&&transferType!=='Dialpad'&& dialpadUI();
  };

  const chooseContact = (ext: string, name: string) => {
    selectedContact(ext, name);
  };

  const contactSearch = (keyPress: any) => {
    setContactList({ ...getContactList, searchKey: keyPress.target.value });
  };
  const addNewCall = () => {
    if (activeCall.contact?.ext.toString() === getContactList.searchKey) {
      toastInformation("Contact is already in an active call!");
    } else {
    let contact: any = incomingCallDetail(getContactList.searchKey) || [];
    selectedContact(getContactList.searchKey,contact?.caller_id||'Unknown Caller');
    toastInformation("Added to call")
    }
  };

  // let contactList: any = contactSearchData(getContactList.searchKey) || [];
  let reg: RegExp = /[a-zA-Z!@#$%^&*()[\],./\\{}~`]/
  return (
    <>
      <div className={`${styles.contactlists}`}>
        <div className={styles.rightbartop}>
          <div className={styles.lefts}>
       {transferType==='Dialpad'&&<span onClick={closeContactPage} className="icon_Strokeleftarrow"></span>}
            {transferType}</div>
          <div className={styles.rights} onClick={closeContactPage}>
            <Tooltip placement="top" title="Close"><span className="icon_close"></span></Tooltip>
          </div>
        </div>
        <div className={`${styles.searchbox} placeholders`}>
          <URInput name="" className={styles.inputsearch} onChange={contactSearch} placeHolder="Type name or number"/>
        {getContactList.searchKey.length>=3&&!reg.test(getContactList.searchKey)&&<div className="addnewcall" onClick={addNewCall}><span className="icon_receiverdial"></span>
          </div>}
        </div>
       
        {filterresContact.length !== 0 ?
        <div className={`scroller dialbooks ${styles.drpDown}`}>

        {(favList?.length > 0 &&getContactList.searchKey==='') && <>
          <div className="titlesdrop">Favourite / Frequently Contacted</div>

          {favList?.map((contactName: any, index: any) => {

            return <div key={index}>
              <div className="dropdowndesign" onClick={() => chooseContact((contactName['ext']).toString(), contactName['caller_id'])}>
                <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`}
                  profileInfo={
                    (contactName.ImageURL !== null && contactName.ImageURL !== "") ?
                      (<>
                        <img src={contactName.ImageURL} alt="" />
                        <URStatusDot className={ userStatusColor(contactName.user_status,'small')}/></>) :
                      (<>
                        <span>{contactName?.caller_id?.charAt(0).toUpperCase()} </span>
                        <URStatusDot className={ userStatusColor(contactName.user_status,'small')} />
                      </>)
                  } />
                <div className="names">{contactName?.caller_id}</div>
                <div className="ext">{contactName.ext }</div>
              </div>
            </div>;
          })}
        </>}
          <>
            

          </>
          {filterresContact?.length > 0 && <> <div className="titlesdrop">Contact</div>
            {filterresContact?.map((contactName: any, index: any) => {
              let highlighted: any = searchHighlight(contactName, getContactList.searchKey);
            return <div key={index}>
              {activeCall?.contact?.sip_login_id !== contactName?.sip_login_id &&
                ((filterresContact[index - 1]?.caller_id)?.charAt(0).toUpperCase()) !==
                ((contactName?.caller_id)?.charAt(0).toUpperCase()) &&
                <div className="titlesdrop">{(contactName?.caller_id)?.charAt(0).toUpperCase()} </div>
              }
              {activeCall?.contact?.sip_login_id !== contactName?.sip_login_id &&
              <div className="dropdowndesign" onClick={() => chooseContact((contactName['ext']).toString(), contactName['caller_id'])}>
              
                <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`}
                  profileInfo={
                    (contactName.ImageURL !== null && contactName.ImageURL !== "") ?
                      (<>
                        <img src={contactName.ImageURL} alt="" />
                        <URStatusDot className={ userStatusColor(contactName.user_status,'small')}/></>) :
                      (<>
                        <span>{contactName?.caller_id?.charAt(0).toUpperCase()} </span>
                        <URStatusDot className={ userStatusColor(contactName.user_status,'small')} />
                      </>)
                  } />
                {getContactList.searchKey !== '' ? 
                <div className="names">{ (highlighted?.middleMsg !== "") ?(<>{ highlighted?.firstMsg}
                  <b className={styles.highlight}>{highlighted?.middleMsg}</b>
                  {highlighted?.lastMsg}</>) :
                    (<>{contactName?.caller_id}</>)}</div> :
                    <div className="names">{contactName.caller_id }</div> }
                <div className="ext">{contactName.ext }</div>
              </div>}
            </div>;

          })}</>}
                     
        </div>
          : <div className={(updatedCallList.minimizedWindow === true && updatedCallList.callIconStatus === 'dialPad') ?
          `${styles.noContactListmin} drpDown` : `${styles.noContactList} drpDown`}>
          
          <NoContent image={noResult}
              title={''}
              description={'Oh, no results found'} />
          
          </div>}
      </div>
    </>
  );
};

